<template>
  <section>
    <header>
      <h1 class="page-header">Forgot password</h1>
    </header>
    <p>Forgot your password? Enter your email below and you'll receive an email with instructions for setting a new one.</p>
    <section class="form-group" v-bind:class="{ 'has-error': (submitAttempted && emailErrorMessage) }">
      <label class="control-label">
        Email
        <input
          v-model="email"
          required
          type="email"
          class="form-control input-lg"
          autofocus
        >
      </label>
      <p v-if="submitAttempted && emailErrorMessage" class="help-block">
        {{ emailErrorMessage }}
      </p>
    </section>
    <button
      v-on:click.prevent="submit()"
      class="btn btn-primary btn-lg btn-block"
    >
      Reset my password
    </button>
  </section>
</template>

<script>
export default {
  name: 'forgot-password',
  data: function () {
    return {
      email: '',
      submitAttempted: false,
    };
  },
  computed: {
    emailErrorMessage: function () {
      if (this.email === '') {
        return 'An email is required';
      } else if (!this.emailValid) {
        return 'Invalid email';
      } else {
        return false;
      }
    },
    emailValid: function () {
      let regex = /\S+@\S+\.\S+/;
      return regex.test(this.email);
    },
  },
  methods: {
    submit: function () {
      if (this.emailErrorMessage) {
        this.submitAttempted = true;
        return;
      }

      this.$http
        .post(`${process.env.BASE_API_URL}/user/reset-password`, { email: this.email })
        .then(function (res) {
          alert('An email was sent. Please check your email and follow the instructions there to finish resetting your password.');
        })
        .catch(function () {
          alert('An email was sent. Please check your email and follow the instructions there to finish resetting your password.');
        })
      ;
    },
  },
};
</script>

<style lang="scss" scoped>
  section, input, button {
    font-size: 18px;
  }

  label {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/forgot-password.vue